import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { initTheme } from "./lib/theme";
initTheme();
import LoginPage from "./pages/LoginPage";
import DashboardLayout from "./pages/DashboardLayout";
import DashboardPage from "./pages/DashboardPage";
import ProductsPage from "./pages/ProductsPage";
import SalesPage from "./pages/SalesPage";
import NewSalePage from "./pages/NewSalePage";
import UsersPage from "./pages/UsersPage";
import SettingsPage from "./pages/SettingsPage";
import PayoutsPage from "./pages/PayoutsPage";
import CustomersPage from "./pages/CustomersPage";
import CouponsPage from "./pages/CouponsPage";
import HomeConfigPage from "./pages/site/HomeConfigPage";
import WebInfoConfigPage from "./pages/site/WebInfoConfigPage";
import WhatsAppConfigPage from "./pages/site/WhatsAppConfigPage";
import ReviewsConfigPage from "./pages/site/ReviewsConfigPage";
import CrystalsPage from "./pages/CrystalsPage";
import PaymentSettingsPage from "./pages/settings/PaymentSettingsPage";
import EmailSettingsPage from "./pages/settings/EmailSettingsPage";
import VipSettingsPage from "./pages/VipSettingsPage";
import InsightsPage from "./pages/InsightsPage";
import ShopLayout from "./pages/shop/ShopLayout";
import ShopHome from "./pages/shop/ShopHome";
import ShopCheckout from "./pages/shop/ShopCheckout";
import ShopThankYou from "./pages/shop/ShopThankYou";

function ProtectedRoute({ children }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="flex h-screen items-center justify-center text-gold-500">
                加载中...
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

function PublicOnly({ children }) {
    const { user } = useAuth();
    if (user === null) return null;
    if (user) return <Navigate to="/" replace />;
    return children;
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <CartProvider>
                <BrowserRouter>
                    <Toaster position="top-right" richColors />
                    <Routes>
                        {/* Public shop routes */}
                        <Route path="/shop" element={<ShopLayout />}>
                            <Route index element={<ShopHome />} />
                            <Route path="checkout" element={<ShopCheckout />} />
                            <Route path="thank-you/:invoiceNo" element={<ShopThankYou />} />
                        </Route>

                        <Route
                            path="/login"
                            element={
                                <PublicOnly>
                                    <LoginPage />
                                </PublicOnly>
                            }
                        />
                        <Route
                            path="/"
                            element={
                                <ProtectedRoute>
                                    <DashboardLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<DashboardPage />} />
                            <Route path="products" element={<ProductsPage />} />
                            <Route path="sales" element={<SalesPage />} />
                            <Route path="sales/new" element={<NewSalePage />} />
                            <Route path="payouts" element={<PayoutsPage />} />
                            <Route path="customers" element={<CustomersPage />} />
                            <Route path="coupons" element={<CouponsPage />} />
                            <Route path="vip" element={<VipSettingsPage />} />
                            <Route path="insights" element={<InsightsPage />} />

                            {/* Landing page config (split into 3) */}
                            <Route path="site/home" element={<HomeConfigPage />} />
                            <Route path="site/info" element={<WebInfoConfigPage />} />
                            <Route path="site/whatsapp" element={<WhatsAppConfigPage />} />
                            <Route path="site/reviews" element={<ReviewsConfigPage />} />
                            <Route path="crystals" element={<CrystalsPage />} />
                            {/* Legacy redirect */}
                            <Route path="landing" element={<Navigate to="/site/home" replace />} />

                            <Route path="users" element={<UsersPage />} />

                            {/* Settings (split: general / payment / email) */}
                            <Route path="settings" element={<SettingsPage />} />
                            <Route path="settings/payment" element={<PaymentSettingsPage />} />
                            <Route path="settings/email" element={<EmailSettingsPage />} />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
                </CartProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
